/** A read-only value with a Copy button (shared by the connect page and the token panel). */
import { useState } from 'react';

import { Button } from './ui/button';

/** Copies text to the clipboard; reports success. */
async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}

export default function CopyField({ label, value }: { label: string; value: string }) {
  const [copied, setCopied] = useState(false);
  return (
    <div className="flex items-center gap-2">
      <code
        aria-label={label}
        className="flex-1 min-w-0 truncate px-[10px] py-[7px] rounded-[var(--r-md)] bg-[var(--bg-inset)] border border-[var(--bd)] text-[12px] text-[var(--tx-hi)] font-[var(--font-mono)]"
      >
        {value}
      </code>
      <Button
        size="sm"
        onClick={() => {
          void copyText(value).then(setCopied);
        }}
        aria-label={`Copy ${label}`}
      >
        {copied ? 'Copied' : 'Copy'}
      </Button>
    </div>
  );
}

